/**
 * AppNav —— 底部主導航（app 外殼）
 * 模組：`@coeldery/bottom-nav`（R1 查到；通用底部導航，自帶 icon＋i18n＋safe-area）。
 * ⚠️ 唔識路由（`onSelect` 交返 app）；全螢幕相機頁唔顯示。
 */
import { useLocation, useNavigate } from 'react-router-dom';
import BottomNav, { type TabDef } from '@coeldery/bottom-nav';

/** 5 個主 tab（次序 ＝ 畫面次序）*/
export const NAV_TABS: readonly TabDef[] = [
  { id: 'home', labelKey: 'nav.home', icon: 'home' },
  { id: 'capture', labelKey: 'nav.capture', icon: 'card' },
  { id: 'list', labelKey: 'nav.list', icon: 'news' },
  { id: 'reports', labelKey: 'nav.reports', icon: 'benefits' },
  { id: 'more', labelKey: 'nav.more', icon: 'setting' },
];

const PATH_OF: Record<string, string> = {
  home: '/',
  capture: '/capture',
  list: '/vouchers',
  reports: '/reports',
  more: '/more',
};

/** 由路徑推返邊個 tab active（唔屬任何 tab → 空字串）*/
export function activeTab(pathname: string): string {
  if (pathname === '/') return 'home';
  if (pathname.startsWith('/capture')) return 'capture';
  if (pathname.startsWith('/vouchers')) return 'list';
  if (pathname.startsWith('/reports')) return 'reports';
  if (pathname.startsWith('/more')) return 'more';
  return '';
}

export default function AppNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <BottomNav
      tabs={NAV_TABS}
      activeId={activeTab(pathname)}
      onSelect={(id) => navigate(PATH_OF[id] ?? '/')}
    />
  );
}
